import { Injectable, EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Loyaltic } from './api-url.constants';
import { Observable, Subject } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { WeatherBonusDecisionRequest } from '../models/weather-bonus.models';

export interface ReportChartConfig {
  showTotalUsers: boolean;
  showMarketingOptIns: boolean;
  showTotalCodes: boolean;
  showTotalRewards: boolean;
  showParticipations: boolean;
  showOptInsChart: boolean;
  showCodeEntriesChart: boolean;
  showRewardsChart: boolean;
  showParticipationsChart: boolean;
  showRegistrationTrend: boolean;
  showReceiptTrend: boolean;
  showRewardTrend: boolean;
  showProductTrend: boolean;
  totalUsersLabel: string;
  marketingOptInsLabel: string;
  totalCodesLabel: string;
  totalRewardsLabel: string;
  participationsLabel: string;
}

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  public pointsEmitter = new EventEmitter<any>();
  public responseLoadedEmitter = new EventEmitter<boolean>();
  isReceiptApproved = false;
  recptPartitionKey = '';
  failedChecks = 0;
  recptRowKey = '';
  scanningReasons:any[] = [];
  public rejectedReasons = [];
  constructor(private http: HttpClient) { }



  signUp(userName:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureEmail, JSON.stringify({ Email: userName }))
      .toPromise().then(response => {
        return response;
      });
  }

  getLiveConfig() {
    return this.http.get(environment.baseUrl + Loyaltic.API.LiveConfig)
      .toPromise().then(response => {
        return response;
      });
  }

  logIn(body:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Login, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  upLoadReceipt(payload:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Upload,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  participate(payload:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Participate,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  RegUploadWithRealTimeScanning(payload:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.RegUploadWithRealTimeScanning,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  loginWithUploadReceipt(payload:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.LoginWithUploadReceipt,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  getRegistrationTrends(startDate?: string, endDate?: string, period: number = 0): Observable<any> {
    let url = environment.baseUrl + Loyaltic.API.RegistrationTrends + `?period=${period}`;
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    return this.http.get(url);
  }

  getReceiptTrends(startDate?: string, endDate?: string, period: number = 0): Observable<any> {
    let url = environment.baseUrl + Loyaltic.API.ReceiptTrends + `?period=${period}`;
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    return this.http.get(url);
  }

  getRewardTrends(startDate?: string, endDate?: string, period: number = 0): Observable<any> {
    let url = environment.baseUrl + Loyaltic.API.RewardTrends + `?period=${period}`;
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    return this.http.get(url);
  }

  getProductTrends(startDate?: string, endDate?: string): Observable<any> {
    let url = environment.baseUrl + Loyaltic.API.ProductTrends;
    const params: string[] = [];
    if (startDate) {
      params.push(`startDate=${startDate}`);
    }
    if (endDate) {
      params.push(`endDate=${endDate}`);
    }
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return this.http.get(url);
  }

  getWeatherBonusStats(startDate?: string, endDate?: string, period: number = 0): Observable<any> {
    let url = environment.baseUrl + Loyaltic.API.WeatherBonusStats + `?period=${period}`;
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    return this.http.get(url);
  }

  fetchReport(type: any, startDate?: string, endDate?: string) {
    let url = environment.baseUrl + `${Loyaltic.API.FetchTotal}/${type}`;
    const params: string[] = [];
    if (startDate) params.push(`startDate=${startDate}`);
    if (endDate) params.push(`endDate=${endDate}`);
    if (params.length > 0) url += '?' + params.join('&');
    return this.http.get(url);
  }

  getReportChartConfig(): Observable<ReportChartConfig> {
    return this.http.get<ReportChartConfig>(environment.baseUrl + Loyaltic.API.ReportChartConfig);
  }

  updateReportChartConfig(config: ReportChartConfig): Observable<ReportChartConfig> {
    return this.http.put<ReportChartConfig>(environment.baseUrl + Loyaltic.API.ReportChartConfig, config);
  }

  getAvailableGames(userId:any) {
    return this.http.get(environment.baseUrl + Loyaltic.API.AvailableGames + '?userid=' + userId).toPromise().then(response => {
      return response;
    });
  }

  play(userId:any, playType:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Play, JSON.stringify({ UserId: userId, PlaySource: playType }))
      .toPromise().then(response => {
        return response;
      });
  }

  getfbBonuspoint(body:any, userId:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.FbSharePoints + '?userid=' + userId, JSON.stringify(body)).toPromise().then(response => {
      return response;
    });
  }

   testwin(rewardid:any) {
    return this.http.get(environment.baseUrl + Loyaltic.API.TestWin + '?reward=' + rewardid)
      .toPromise().then(response => {
        return response;
      });
  }



  captureAddress(body:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureAddress, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  captureDigitalWin(payload:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureDigitalWin , payload)
      .toPromise().then(response => {
        return response;
      });
  }

  stripePay(body:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.StripePay, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  confirmReceiptUpload(partitionKey:any, rowKey:any) {
    return this.http.post(environment.baseUrl +
      Loyaltic.API.confirmuploadafterscanning + '?PartitionKey=' + partitionKey + '&RowKey=' + rowKey, null)
      .toPromise().then(response => {
        return response;
      });
  }

  Notifyuser(userid:any, RewardPartitionkey:any) {
    return this.http.post(environment.baseUrl +
      Loyaltic.API.Notifyuser + '?userId=' + userid + '&RewardPartitionkey=' + RewardPartitionkey, null)
      .toPromise().then(response => {
        return response;
      });
  }

  emailReminder(body:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Emailreminder, JSON.stringify(body)).toPromise().then(response => {
      return response;
    });
  }

  register(body:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Register, JSON.stringify(body)).toPromise().then(response => {
      return response;
    });
  }

  forgotPassword(email:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.ForgotPassword, JSON.stringify({ Email: email }))
      .toPromise().then(response => {
        return response;
      });
  }

  resetPassword(body:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.ResetPassword, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  getLatestAddress(id:any) {
    return this.http.get(environment.baseUrl + Loyaltic.API.LatestAddress + '?userId=' + id).toPromise().then(response => {
      return response;
    });
  }

  postOrderReward(body:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.OrderReward, JSON.stringify(body)).toPromise().then(response => {
      return response;
    });
  }

  getRewards(culture:any, userId = null) {
    let query = `?culture=${culture}`;
    if (userId) {
      query = `${query}&userid=${userId}`;
    }
    return this.http.get(environment.baseUrl + Loyaltic.API.Rewards + query).toPromise().then(response => {
      return response;
    });
  }


  getprofile(userId:any) {  
    return this.http.get(environment.baseUrl + Loyaltic.API.profile + '?userId=' + userId).toPromise().then(response => {
      return response;
    });
  }

  getPoints(userId:any) {
    return this.http.get(environment.baseUrl + Loyaltic.API.Points + '?userid=' + userId)
      .toPromise().then(response => {
        return response;
      });
  }

  getProducts(){
    return this.http.get(environment.baseUrl + Loyaltic.API.products).toPromise().then(response => {
      return response;
    })
  }

  submitWeatherBonusDecision(body: WeatherBonusDecisionRequest) {
    return this.http.post(environment.baseUrl + Loyaltic.API.WeatherBonus, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

pay(body:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.pay, JSON.stringify(body)).toPromise().then(response => {
      return response;
    });
  }

  updateRewardNotification(userid:any, RewardPartitionkey:any, isUserNotified:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Notifyuser, JSON.stringify({
      userId: userid,
      RewardPartitionkey,
      isUserNotified
    }))
      .toPromise().then(response => {
        return response;
      });
  }

}
